export default __webpack_public_path__ + "static/media/gymnastics_controversy.581d0b69.png";